import apiClient from '../utils/apiClient';

export const getDeviceValues = async () => {
  try {
    const response = await apiClient.get(`/Values/Home`, {
      headers: {},
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch device values');
  }
};
